// import './appState';
import './keyboard';
import { generate } from './form';

generate();
